module.exports = __webpack_public_path__ + "static/media/myJam-dashboard.3cbcc711.png";